import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import * as Auth from 'auth/components';

import { resetPassword } from 'auth/actions';
import { addSingleInlineMessage, clearInlineMessages } from 'messages/actions';

class ResetPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: { password: '' },
      token: '',
      isValid: false,
      isSubmitted: false,
      isLoading: false,
    };
  }

  componentWillMount = () => {
    this.props.clearInlineMessages();
    this.setState({ token: qs.parse(this.props.location.search).token });
  };

  handleValueChange = (e, field) => {
    this.setState({
      values: {
        ...this.state.values,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = ({ isValid }, data) => {
    this.setState(
      { isSubmitted: true },
      () =>
        isValid &&
        this.props
          .resetPassword(this.state.token, this.state.values.password)
          .then((result) => {
            this.props.history.push('/auth/login');
            this.props.addSingleInlineMessage(result.value.message, 'success');
          })
          .catch((err) => this.props.addSingleInlineMessage(err.message, 'danger'))
    );
  };

  handleValidation = (isValid, message) => {
    this.setState({ isValid }, () => {
      this.props.clearInlineMessages();
      if (!this.state.isValid && this.state.isSubmitted) {
        this.props.addSingleInlineMessage(message, 'danger');
      }
    });
  };

  render = () => (
    <Auth.ResetPasswordView
      handleSubmit={this.handleSubmit}
      handleValidation={this.handleValidation}
      handleValueChange={this.handleValueChange}
      isLoading={this.props.isLoading}
      isSubmitted={this.state.isSubmitted}
      values={this.state.values}
    />
  );
}

ResetPasswordContainer.propTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.auth.isLoading,
});

const mapDispatchToProps = {
  resetPassword,
  addSingleInlineMessage,
  clearInlineMessages,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  translate()
)(ResetPasswordContainer);



// WEBPACK FOOTER //
// src/modules/auth/containers/ResetPasswordContainer.js